// extracted by mini-css-extract-plugin
export default {"ReferralsPage":"styles_ReferralsPage__t3-6X","title":"styles_title__ls+RY","content":"styles_content__AOeOL"};